// src/components/Tasks/TaskFormDialog.tsx
import { ReactNode, useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/Base/Dialog";
import { Card, Task } from "@/types/v2";
import { TaskForm } from "./TaskForm";
import { TaskFormValues } from "./TaskForm.schema";

export interface TaskFormDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  task?: Task;
  initialRelatedRO?: Card["id"];
  initialValues?: Partial<TaskFormValues>;
  trigger?: ReactNode;
}

export const TaskFormDialog = ({
  open,
  onOpenChange,
  task,
  initialRelatedRO,
  initialValues,
  trigger,
}: TaskFormDialogProps) => {
  const [isOpen, setIsOpen] = useState(open ?? false);

  useEffect(() => {
    if (typeof open === "boolean") {
      setIsOpen(open);
    }
  }, [open]);

  const handleOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen);
    onOpenChange?.(newOpen);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="max-h-[90vh] max-w-screen-sm overflow-auto">
        <DialogHeader className="border-b pb-4">
          <DialogTitle className="text-xl font-bold">
            {task ? "Edit task" : "Create task"}
          </DialogTitle>
        </DialogHeader>
        <TaskForm
          task={task}
          initialRelatedRO={initialRelatedRO}
          initialValues={initialValues}
          onSuccess={() => handleOpenChange(false)}
          onCancel={() => handleOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
